module.exports = __webpack_public_path__ + "public/images/monitor-class-celebration.bb0c75e0de7712b70763dabbc73b84d5.png";